export default function () {
    return {
        cities: [],
        counties: [],
        seo: null,
        nearbyHomes: [],
    };
}
